import { U21Chip } from 'app/shared/u21-ui/components';
import React from 'react';
import {
  FullTxnResponse,
  ShortTxnResponse,
} from 'app/modules/transactions/types';
import pluralize from 'pluralize';

import {
  CachedActionEventResponse,
  ShortActionEventResponse,
} from 'app/modules/actionEvents/responses';
import { useFingerprintCount } from 'app/modules/deviceIntelligence/hooks/fingerprint';
import { IconDevices } from '@u21/tabler-icons';

type DeviceIntelligenceChipProps = {
  event: 'txn' | 'action';
  row:
    | FullTxnResponse
    | CachedActionEventResponse
    | ShortActionEventResponse
    | ShortTxnResponse;
};

export const DeviceIntelligenceChip = ({
  event,
  row,
}: DeviceIntelligenceChipProps) => {
  const trueCount = useFingerprintCount(event, row);
  return (
    <U21Chip color={trueCount > 0 ? 'error' : 'default'} icon={<IconDevices />}>
      {pluralize('Signal', trueCount, true)}
    </U21Chip>
  );
};
